import { Link } from 'react-router-dom';
import type { UserAccountStatus } from '../../api/apiSchemas';
import { useIdentities, useSession } from '../../auth/authQueries';
import { Avatar } from '../../components/account/Avatar';
import { ROUTES } from '../../lib/routes';
import '../../components/account/account.css';

const STATUS_LABEL: Record<UserAccountStatus, string> = {
  ACTIVE: 'Đang hoạt động',
  PENDING_ONBOARDING: 'Chưa hoàn tất',
  SUSPENDED: 'Tạm khóa',
  PENDING_REVIEW: 'Đang chờ xét duyệt',
};

const QUICK_ACTIONS = [
  { to: ROUTES.profile, title: 'Hồ sơ cá nhân', sub: 'Cập nhật thông tin của bạn' },
  { to: ROUTES.connections, title: 'Phương thức đăng nhập', sub: 'Quản lý liên kết tài khoản' },
  { to: ROUTES.security, title: 'Bảo mật & phiên', sub: 'Thiết bị và đăng xuất' },
];

export default function AccountPage() {
  const session = useSession();
  const identities = useIdentities(true);

  if (!session.data?.authenticated) return null;
  const user = session.data.user;
  const connectedCount = identities.data?.identities.length ?? null;

  return (
    <div className="stack">
      <h1>Tổng quan tài khoản</h1>

      <div className="summary">
        <Avatar ring size={56} displayName={user.displayName} pictureUrl={user.pictureUrl} />
        <div className="summary__info">
          <span className="summary__name">{user.displayName ?? 'Người dùng'}</span>
          <span className="summary__email">{user.email ?? 'Chưa có email'}</span>
        </div>
        {user.email ? (
          <span className={`pill ${user.emailVerified ? 'pill--verified' : 'pill--warn'}`}>
            {user.emailVerified ? 'Đã xác minh' : 'Chưa xác minh'}
          </span>
        ) : null}
      </div>

      <div className="stats">
        <div className="stat">
          <span className="stat__label">Trạng thái</span>
          <span className="stat__value">
            <span
              className={`dot ${user.status === 'ACTIVE' ? 'dot--success' : 'dot--warn'}`}
              aria-hidden="true"
            />
            {STATUS_LABEL[user.status]}
          </span>
        </div>
        <div className="stat">
          <span className="stat__label">Phương thức đăng nhập</span>
          <span className="stat__value">
            {connectedCount === null ? '…' : `${connectedCount} đã liên kết`}
          </span>
        </div>
      </div>

      <nav className="actions" aria-label="Quản lý tài khoản">
        {QUICK_ACTIONS.map((action) => (
          <Link key={action.to} className="action" to={action.to}>
            <span>
              <span className="action__title">{action.title}</span>
              <span className="action__sub">{action.sub}</span>
            </span>
            <span className="action__arrow" aria-hidden="true">
              →
            </span>
          </Link>
        ))}
      </nav>
    </div>
  );
}
